import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from './services';
import { TranslateModule } from '@ngx-translate/core';

import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { WechatEntryComponent } from './wechat-entry/wechat-entry.component';


const routes: Routes = [
  { path: 'wechat-entry', component: WechatEntryComponent },
  { path: '', redirectTo: 'accounts', pathMatch: 'full' },
  {
    path: 'accounts',
    loadChildren: () => import('./accounts/accounts.module').then(m => m.AccountsModule)
  },
  {
    path: 'contents',
    canLoad: [AuthGuardService],
    loadChildren: () => import('./contents/contents.module').then(m => m.ContentsModule)
  },
  {
    path: 'contentssub',
    canLoad: [AuthGuardService],
    loadChildren: () => import('./contents-sub/contents-sub.module').then(m => m.ContentsSubModule)
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes), TranslateModule],
  exports: [RouterModule],
  providers: [AuthGuardService]
})
export class AppRoutingModule { }
